import { isAbortError } from '@disy/lib/abort-error';
import { logger } from '@disy/lib/logging';

import { deleteWorkOrders } from 'cadenza/api-client/workorder-api';
import type { EnrichmentResultEvent } from 'cadenza/geocoding/geocoding-progress-dialog/geocoding-progress-dialog';
import { observeWithGeocodingProgressDialog } from 'cadenza/geocoding/geocoding-progress-dialog/open-geocoding-progress-dialog';
import type { GeocodingEnrichmentType } from 'cadenza/repository/model/enrichment-type';
import { getGeocodingType } from 'cadenza/repository/model/enrichment-type';
import type { DownstreamEnrichmentRequest } from 'cadenza/selfservice/import-data/api/downstream-enrichment-request';
import { getStore } from 'cadenza/store/cadenza-store';
import { startEnrichment } from 'cadenza/workbook/api/enrichment-api';
import { createEnrichmentErrorAlert } from 'cadenza/workbook/enrichment/enrichment-utils';
import { getWorkbookNameAndHash } from 'cadenza/workbook/workbook-core-selectors.state';

export async function executeDownstreamEnrichment(
  downstream: DownstreamEnrichmentRequest<GeocodingEnrichmentType>,
): Promise<EnrichmentResultEvent | undefined> {
  const workOrderId = await startEnrichment(
    getWorkbookNameAndHash(getStore().getState()),
    downstream.type,
    downstream.request,
  );
  // assumes all downstream enrichments use the geocodingProgressDialog for now
  const geocodingType = getGeocodingType(downstream.type);
  try {
    return await observeWithGeocodingProgressDialog(workOrderId, geocodingType);
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }
    logger.error('Failed to execute Enrichment', error);
    await createEnrichmentErrorAlert(downstream.type, error);
    return;
  } finally {
    await deleteWorkOrders([workOrderId]);
  }
}
